import { useLayoutEffect, useEffect } from 'react'; // suppress the useLayoutEffect warning on server side.

export var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd/dist/esm/hooks/internal/useIsomorphicLayoutEffect.js
// module id = 156
// module chunks = 43